import React, { useState, useEffect } from "react";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import styles from "./SubMapping.module.css";
import { getFixedAssetSubmappingCategory } from "../../../../Bookclosure/Services/ApiHandler";

export default function Category({ FixedAssetID, onMappingChange }) {
  const [selectedValues, setSelectedValues] = useState({});
  const [dropDownOptions, setDropDownOptions] = useState([]);
  const [categoryLabels, setCategoryLabels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);

        const response = await getFixedAssetSubmappingCategory(FixedAssetID);
        console.log("Category API response:", response);

        const fields = response.fields || response.data?.fields || [];
        const labels = response.labelList || response.data?.labelList || [];

        setDropDownOptions(fields);
        setCategoryLabels(labels);
      } catch (err) {
        console.error("Error fetching category data:", err);
        setError("Failed to load dropdown data.");
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [FixedAssetID]);

  const handleFieldChange = (label, value) => {
    const updated = { ...selectedValues, [label]: value };
    setSelectedValues(updated);
    onMappingChange && onMappingChange(updated);
  };

   if (loading) return <p>Loading dropdown…</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div className={styles.formGroup}>
      {categoryLabels.map((label) => (
        <CustomDropdown
          key={label}
          label={label}
          value={selectedValues[label] || ""}
          onChange={(value) => handleFieldChange(label, value)}
          options={dropDownOptions}
          placeholder="Map Column"
        />
      ))}
    </div>
  );
}
